export default __webpack_public_path__ + "static/media/4.6f27dd44.jpg";